import { useQuery } from "@tanstack/react-query";
import type { UserRole } from "@agp/shared";
import { useApi } from "@/hooks/useApi";

export interface Me {
  id: string;
  email: string;
  role: UserRole;
}

export function useMe(): Me | null {
  const api = useApi();
  const query = useQuery({
    queryKey: ["me"],
    queryFn: () => api.get<Me>("/api/me"),
    staleTime: 5 * 60 * 1000,
  });
  return query.data ?? null;
}
